<div class="m-datepicker"
     :class="{ 'm--is-disabled': isDisabled,
            'm--is-readonly': isReadonly,
            'm--is-waiting': isWaiting,
            'm--has-error': hasCalandarError,
            'm--is-valid': isValid,
            'm--has-validation-message': hasValidationMessage }"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
     @click="onClick">
    <m-input-style v-m-popup:popup
                   :disabled="isDisabled"
                   :label="label"
                   :label-for="id"
                   :readonly="isReadonly"
                   :required-marker="requiredMarker"
                   :waiting="isWaiting"
                   :focus="isFocus"
                   :label-up="labelUp"
                   :empty="isEmpty"
                   :error="hasCalandarError"
                   :valid="isValid">
        <m-input-mask ref="input"
                      :id="id"
                      :aria-haspopup="true"
                      :aria-expanded="open"
                      :disabled="isDisabled || isWaiting"
                      :readonly="isReadonly || isLessThanTablet"
                      :options="inputOptions"
                      :placeholder="propPlaceholder"
                      :raw="false"
                      :value="inputModel"
                      autocomplete="off"
                      @focus="onFocus"
                      @blur="onBlur"
                      @input="inputDate($event)"
                      @keyup="onKeyup"
                      @keydown="onKeydown">
        </m-input-mask>
        <m-icon-button class="m-datepicker__icon"
                       slot="suffix"
                       :aria-controls="id"
                       button-size="22px"
                       :disabled="!active"
                       icon-name="m-svg__calendar"
                       @click="togglePopup($event)">
            <m-i18n k="m-datepicker:open"
                    v-if="!open"></m-i18n>
            <m-i18n k="m-datepicker:close"
                    v-if="open"></m-i18n>
        </m-icon-button>
    </m-input-style>

    <div class="m-datepicker__validation">
        <m-validation-message class="m-datepicker__validation__message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasCalandarError"
                              :error-message="calandarErrorMessage"
                              :valid-message="validMessage"
                              :helper-message="helperMessage"></m-validation-message>
    </div>

    <m-popup ref="popup"
             :open.sync="open"
             :disabled="!active"
             :close-on-backdrop="true"
             :focus-management="isMqMaxS"
             open-trigger="manual"
             :padding="false"
             placement="bottom"
             @open="onOpen"
             @close="onClose">
        <h2 v-if="label && isMqMaxS"
            class="m-datepicker__header-label"
            slot="header">{{label}}</h2>
        <m-calendar :min-date="minDateString"
                    :max-date="maxDateString"
                    :type="type"
                    :visible="open"
                    :initial-view="initialView"
                    :show-month-before-after="false"
                    :value="formattedDate"
                    @input="selectDate"></m-calendar>
    </m-popup>
</div>
